import { FormUnsavedChangesWrapper } from 'components';
import { OutcomeMeasuresHeader } from 'components/header';
import { useEffect } from 'react';

import { useReducer } from 'lib/hooks/useReducer';
import { useDispatch } from 'react-redux';

import { Layout } from 'antd';

import dhiInventories, { DhiInventory, initialState } from './dhiSlice';

import { setFaqObject } from 'navigation/utils/navigationSlice';

import { cleanPagedQuestionnaireStorage } from 'features/patient/assessment/_utils/questionnaire-local-storage';
import { DhiQuestionnaire } from 'features/patient/_utils/questionnaires';
import { formatQuestionnaireData } from '../cgs/cgs-pagination-combined';
import { PaginationCombined } from './dhi-pagination-combined';

export function PatientDhi() {
  const faqDispatch = useDispatch();

  const [{ dhi }] = useReducer(dhiInventories, initialState);

  useEffect(() => {
    faqDispatch(
      setFaqObject({
        instructions: dhi.instructions,
        description: dhi.description,
        min: dhi.min,
        max: dhi.max
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout style={{ backgroundColor: 'white' }}>
      <OutcomeMeasuresHeader
        label={'Exit'}
        title="4th Questionnaire"
        onExit={() => {
          cleanPagedQuestionnaireStorage('questionnaire-dhi');
        }}
      />
      <FormUnsavedChangesWrapper>
        {Object.keys(dhi).length && (
          <PaginationCombined storageKey={'questionnaire-dhi'} />
        )}
      </FormUnsavedChangesWrapper>
    </Layout>
  );
}

// purpose is to standardize paginationCombined data intake;
export function formatDhi(data: DhiInventory, pageLimit: number) {
  return formatQuestionnaireData(DhiQuestionnaire, data, pageLimit);
}
